export default __webpack_public_path__ + "static/eftLanding-309011ad011d1fa7bff0584d89ac9eda.webp";